module.exports = __webpack_public_path__ + "df6360633d76bb1f88142ffb1eb0f848.svg";